module.exports = __webpack_public_path__ + "img/Colorize05.aff8d05b.png";